
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

interface CompanyLogoProps {
  profile: any;
}

const CompanyLogo = ({ profile }: CompanyLogoProps) => {
  const [companyData, setCompanyData] = useState<{logo_url?: string, name?: string} | null>(null);
  const { user } = useAuth();

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (!user?.id || !profile?.company_id) return;

      try {
        const { data: company } = await supabase
          .from('companies')
          .select('logo_url, name')
          .eq('id', profile.company_id)
          .single();

        if (company) {
          setCompanyData(company);
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
      }
    };

    fetchCompanyData();
  }, [user?.id, profile?.company_id]);

  if (!companyData?.logo_url) return null;

  return (
    <div className="mb-6 flex justify-center">
      <img 
        src={companyData.logo_url} 
        alt={`${companyData.name || 'Company'} logo`}
        className="h-32 max-w-[500px] object-contain"
      />
    </div>
  );
};

export default CompanyLogo;
